import { BookingsBulkMovePayload } from "PFCore/services/bookings_bulk_move";
import { useMemo } from "react";

import { CalendarMode, Row } from "../../../../types";
import { RowType } from "../../../../types/row";
import { useBookingRowsContext } from "../../context/booking_rows_context";
import {
  findClosestParent,
  findRootParent
} from "../../context/booking_rows_context/booking_rows_context.utils";
import { useBookingsOverviewContext } from "../../context/bookings_overview_context";

type UseRowMenuSelectAllBookingsPayload = {
  row: Row;
};

export const useRowMenuSelectAllBookingsPayload = ({ row }: UseRowMenuSelectAllBookingsPayload) => {
  const { calendarMode } = useBookingsOverviewContext();
  const { rowsByKey } = useBookingRowsContext();

  const selectionPayload: Pick<BookingsBulkMovePayload, "filters" | "exclude"> = useMemo(() => {
    if (calendarMode === CalendarMode.Projects) {
      if (row.type === RowType.Profile) {
        const closestParent = findClosestParent(row, rowsByKey);
        const closestParentId = closestParent?.original.id;
        const isProfileLinkedToEngagement = closestParent?.type === RowType.Engagement;

        return {
          filters: [
            {
              profileId: row.original.id,
              activityId: closestParentId,
              includeChildren: !isProfileLinkedToEngagement
            }
          ]
        };
      } else {
        const filters = [
          {
            activityId: row.original.id,
            includeChildren: true
          }
        ];

        return { filters };
      }
    }
    if (calendarMode === CalendarMode.Workforce) {
      const profileId = findRootParent(row, rowsByKey).original.id;

      return {
        filters: [
          {
            activityId: row.original.id,
            profileId
          }
        ]
      };
    }
    return {
      filters: []
    };
  }, [calendarMode, row, rowsByKey]);
  return { selectionPayload };
};
